import type { ApiRoute, NoBody } from "../api"
import type { FinancingFormProductDetailsView } from "../vehicleDetails/overview/financing/FinancingFormProductDetailsView"

export interface GetFinancingProductDetailsViewPathParams {
	inventoryId: string
}

export interface GetFinancingProductDetailsViewQueryParams {
	id: string | undefined
	type: string
}

export const getFinancingProductDetailsViewRoute: ApiRoute<
	GetFinancingProductDetailsViewPathParams,
	GetFinancingProductDetailsViewQueryParams,
	NoBody,
	FinancingFormProductDetailsView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/financing-product`,
	method: "get",
	path: "/vehicles/:inventoryId/financing-product",
}
